export default __webpack_public_path__ + "static/unilever144x144-7280957c0558e5ae28484cd150282ecf.svg";